// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BackButton-module__content___vgase {\n  width: 33px;\n  height: 33px;\n  background-color: #ffffff;\n  border-radius: 4px;\n  border: #E3DFDC solid 1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "BackButton-module__content___vgase"
};
export default ___CSS_LOADER_EXPORT___;
